import { defineRows, FieldTemplate, TemplateRow } from '../../../app/components/fields-template/field-template';
import type { entityTypes } from '../entitytypes';
import { BASE_ROWS } from './base';

type WorkplaceET = (typeof entityTypes)['workplace'];

export class WorkplaceTemplate implements FieldTemplate {
    rows: TemplateRow[] = defineRows<WorkplaceET>([
        ...BASE_ROWS,
        {
            type: 'row',
            children: [{ type: 'field', fieldKey: 'behoefteUren', fieldGroup: 'pheData', classes: 'col-24 col-md-8' }],
        },
    ]);
}
